import React from 'react';
import { Menu } from '@milanote/roma';
import { GridListHeader, GridListSection as AriaGridListSection, Key } from 'react-aria-components';

import LabelListItem from './LabelListItem';
import { Label } from '../../../../../../../common/labels/labelTypes';
import { cx } from '@milanote/roma/utils/cx';

type Props = {
    checkedLabelIds: Set<Key>;
    editingLabelId: string | null;
    header?: string;
    handleClickEdit?: (label: Label) => void;
    isSheet?: boolean;
    labels: Label[];
    onEditingChange: (labelId: string, nextIsEditing: boolean) => void;
    sectionClassName?: string;
    sectionId?: string;
    showSeparator?: boolean;
};

const LabelListSection: React.FC<Props> = ({
    checkedLabelIds,
    editingLabelId,
    header,
    handleClickEdit,
    isSheet = false,
    labels,
    onEditingChange,
    sectionClassName,
    sectionId,
    showSeparator = false,
}) => {
    if (!labels.length) return null;

    const content = (
        <>
            {(header || showSeparator) && (
                <GridListHeader>
                    {showSeparator && <Menu.Base.Separator className={cx(!header && 'pb-0.5')} />}
                    {header && <Menu.Base.Header className="px-4">{header}</Menu.Base.Header>}
                </GridListHeader>
            )}
            {labels.map((label) => (
                <LabelListItem
                    key={label._id}
                    label={label}
                    onEditingChange={onEditingChange}
                    onEditClick={handleClickEdit}
                    isSheet={isSheet}
                    isSelected={checkedLabelIds.has(label._id)}
                    isEditing={editingLabelId === label._id}
                />
            ))}
        </>
    );

    if (!sectionId) return content;

    return (
        <AriaGridListSection id={sectionId} className={sectionClassName}>
            {content}
        </AriaGridListSection>
    );
};

export default LabelListSection;
